module.exports = __webpack_public_path__ + "static/media/12448_05big.3f5fbca1.jpg";